import React from "react";

/** Etiqueta de seção com pontinho pulsante. */
const SectionLabel = ({ children, tone = "teal", className = "" }) => {
  const tones = {
    teal: "text-tealVitality bg-tealVitality/10 ring-tealVitality/20",
    amber: "text-pawOrange bg-pawOrange/10 ring-pawOrange/20",
    light: "text-tealGlow bg-white/10 ring-white/15",
  };

  return (
    <span
      className={`inline-flex items-center gap-2.5 rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] ring-1 ${
        tones[tone] || tones.teal
      } ${className}`}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-current opacity-70" />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-current" />
      </span>
      {children}
    </span>
  );
};

export default SectionLabel;
